import { Fragment } from "react";

export type CopyBlock = { type: "paragraph"; text: string } | { type: "list"; items: string[] };
export type CopySection = { title: string; blocks: CopyBlock[] };

/** A small, text-only format: headings, paragraphs, bullets and bold. No raw HTML. */
export function parseJobDescription(description: string): CopySection[] {
  const sections: CopySection[] = [{ title: "", blocks: [] }];
  for (const raw of description.split(/\r?\n/)) {
    const line = raw.trim();
    if (!line) continue;
    const heading = line.match(/^#{1,3}\s+(.+)$/);
    if (heading) { sections.push({ title: heading[1], blocks: [] }); continue; }
    const blocks = sections[sections.length - 1].blocks;
    const bullet = line.match(/^(?:[-*•])\s+(.+)$/);
    if (bullet) {
      const previous = blocks[blocks.length - 1];
      if (previous?.type === "list") previous.items.push(bullet[1]);
      else blocks.push({ type: "list", items: [bullet[1]] });
    } else blocks.push({ type: "paragraph", text: line });
  }
  return sections.filter((section) => section.title || section.blocks.length);
}

export function usPhoneHref(phone: string): string | undefined {
  const digits = phone.replace(/\D/g, "");
  if (/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return `tel:+1${digits}`;
  if (/^1[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return `tel:+${digits}`;
  return undefined;
}

function InlineCopy({ text }: { text: string }) {
  return <>{text.split(/(\*\*[^*]+\*\*)/g).map((part, index) => part.startsWith("**") && part.endsWith("**")
    ? <strong key={index}>{part.slice(2, -2)}</strong> : <Fragment key={index}>{part}</Fragment>)}</>;
}

export function JobDescriptionBlocks({ blocks }: { blocks: CopyBlock[] }) {
  return <>{blocks.map((block, blockIndex) => {
      if (block.type === "list") return <ul key={blockIndex}>{block.items.map((item, itemIndex) => <li key={itemIndex}><InlineCopy text={item}/></li>)}</ul>;
      const phone = block.text.match(/^CALL NOW:\s*(.+)$/i)?.[1];
      const href = phone ? usPhoneHref(phone) : undefined;
      return phone ? <p className="offer-contact" key={blockIndex}><span>Call now</span>{href ? <a href={href}>{phone}</a> : <strong>{phone}</strong>}</p>
        : <p key={blockIndex}><InlineCopy text={block.text}/></p>;
    })}</>;
}

export function JobDescription({ description }: { description: string }) {
  return <div className="job-description">{parseJobDescription(description).map((section, index) => <section className={`offer-section${section.title ? "" : " offer-intro"}`} key={index}>
    {section.title ? <h2>{section.title}</h2> : null}
    <JobDescriptionBlocks blocks={section.blocks}/>
  </section>)}</div>;
}
